import Highcharts from 'highcharts';
import { Dispatch, SetStateAction, useCallback, useState } from 'react';

export interface UseTableDataResult {
	dataTable: any[];
	setDataTable: Dispatch<SetStateAction<any[]>>;
	expandedRowKeys: string[];
	setExpandedRowKeys: Dispatch<SetStateAction<string[]>>;
	columnsExpanded: any[];
	setColumnsExpanded: Dispatch<SetStateAction<any[]>>;
	columnsAnnotationsModal: any[];
	setColumnsAnnotationsModal: Dispatch<SetStateAction<any[]>>;
	queryParams: string;
	setQueryParams: Dispatch<SetStateAction<string>>;
	dynamicStats: Record<string, any>;
	setDynamicStats: Dispatch<SetStateAction<Record<string, any>>>;
	buildDataToTable: (dataArray: any[], selectedParamsList: any[]) => any[];
	getColor: (
		currentValue: number,
		criticalHigh: number,
		criticalHhigh: number,
		criticalLow: number,
		criticalLlow: number,
	) => string;
}

export const useTableData = (): UseTableDataResult => {
	const [dataTable, setDataTable] = useState<any[]>([]);
	const [expandedRowKeys, setExpandedRowKeys] = useState<string[]>([]);
	const [columnsExpanded, setColumnsExpanded] = useState<any[]>([]);
	const [columnsAnnotationsModal, setColumnsAnnotationsModal] = useState<any[]>([]);
	const [queryParams, setQueryParams] = useState<string>('');
	const [dynamicStats, setDynamicStats] = useState<Record<string, any>>({});

	const buildDataToTable = useCallback((resumeList: any[], selectedParamsList: any[]) => {
		const colors = Highcharts.getOptions().colors;
		if (!colors) return [];
		return resumeList
			.filter((item) => {
				return item !== null;
			})
			.map((resume, index) => {
				return {
					parameter: resume.parameterName,
					parameterId: resume.parameterId,
					type: resume.sourceType,
					unit: resume.unit,
					criticalHigh: resume.criticalHigh,
					criticalHhigh: resume.criticalHhigh,
					criticalLow: resume.criticalLow,
					criticalLlow: resume.criticalLlow,
					currentValue: resume.currentValue,
					lastCollected: resume.lastCollected,
					usage: resume.usage,
					sourceName: resume.sourceName,
					maximun: resume.max,
					minimum: resume.min,
					average: resume.average,
					sum: resume.sum,
					source: resume.sourceName,
					infrastructureId: resume.infrastructureId,
					key: resume.parameterId,
					infrastructureName: resume.infrastructureName,
				};
			});
	}, []);

	const getColor = useCallback(
		(
			currentValue: number,
			criticalHigh: number,
			criticalHhigh: number,
			criticalLow: number,
			criticalLlow: number,
		) => {
			if (currentValue === null || currentValue === undefined) return '';

			if (criticalHhigh !== null && criticalHhigh !== undefined && currentValue >= criticalHhigh) {
				return '#ff4d4f';
			}

			if (criticalHigh !== null && criticalHigh !== undefined && currentValue >= criticalHigh) {
				return '#faad14';
			}

			if (criticalLlow !== null && criticalLlow !== undefined && currentValue <= criticalLlow) {
				return '#ff4d4f';
			}

			if (criticalLow !== null && criticalLow !== undefined && currentValue <= criticalLow) {
				return '#faad14';
			}

			return '#52c41a';
		},
		[],
	);

	return {
		dataTable,
		setDataTable,
		expandedRowKeys,
		setExpandedRowKeys,
		columnsExpanded,
		setColumnsExpanded,
		columnsAnnotationsModal,
		setColumnsAnnotationsModal,
		queryParams,
		setQueryParams,
		dynamicStats,
		setDynamicStats,
		buildDataToTable,
		getColor,
	};
};
